import { createFileRoute } from '@tanstack/react-router';
import PasskeyVerification from '@/pages/PasskeyVerification';

export const Route = createFileRoute('/_authenticated/verify-passkey')({
  component: PasskeyVerification,
});
